import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
// import { settingsLayoutComponents } from '~/pages/layout/layout';
import { RouteKeys } from '~/router/routes.domain';

export const ProfileRoute: RouteRecordRaw = {
	name: RouteKeys.PROFILE_INFOS,
	path: 'profile-infos',
	components: {
		default: () => import('../profile/ui/pages/ProfileInfosPage.vue')
	},
	meta: {
		label: 'profile.infos.navigation',
		icon: () => $i('profile-infos'),
		requiresAuth: true,
		isSettingsNavEntry: true,
		isSubEntry: false,
		order: 1
	}
};
